<script setup>

import { computed } from 'vue';

const props = defineProps({

  displayType: String,

  width: {
    type: Number,
    default: 540
  },

  highlight: {type: String, default: '#274e77'}

})

const highlightColor = computed(() => {

  return props.highlight;
})

</script>

<template>
  <div class="cmp-booking-summary-display_container" :style="{width: props.width + 'px'}">
    <div class="cmp-booking-summary-display_title-icon-area">
      <div class="cmp-booking-summary-display_title-icon">
        <slot name="icon"></slot>
      </div>
      <div class="cmp-booking-summary-display_title-text">
        <slot name="title"></slot>
      </div>
    </div>
    <div class="cmp-booking-summary-display_content" v-if="props.displayType === 'address'">
      <div class="cmp-booking-summary-display_content-heading">
        <slot name="heading"></slot>
      </div>
      <div class="cmp-booking-summary-display_content-extra">
        <slot name="second-content"></slot>
      </div>
      <div class="cmp-booking-summary-display_content-extra">
        <slot name="third-content"></slot>
      </div>
      <div class="cmp-booking-summary-display_content-extra">
        <slot name="fourth-content"></slot>
      </div>
    </div>
    <div v-else id="grid-area" class="cmp-booking-summary-display_content-grid">
      <div>
        <slot :name="1"></slot>
      </div>
      <div>
        <slot :name="2"></slot>
      </div>
      <div>
        <slot :name="3"></slot>
      </div>
      <div>
        <slot :name="4"></slot>
      </div>
    </div>
    <div>
      <slot name="placeholder"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>

#grid-area div {
  border-right: 1px solid #f3f3f3;
}

#grid-area div:last-of-type {
  border-right: none;
}

.cmp-booking-summary-display {

  &_container {
    position: relative;
    display: flex;
    height: 70px;
    //border: 1px solid #f3f3f3;
    //border-left: 6px solid v-bind(highlightColor);
    border-radius: var(--rounded-corners);
    background-color: #ffffff;
    margin-bottom: 10px;
    box-shadow: 1px 1px 8px 0px #d2d2d2;
  }

  &_title-icon-area {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 100%;
    border-right: 1px solid var(--border-color);
    //background-color: #f9f9f9;
  }

  &_title-icon {
    position: absolute;
    top: 17px;
    left: 1px;
    opacity: 0.5;
  }

  &_title-text {
    font-size: 17px;
    //font-weight: bold;
    z-index: 99;
  }

  &_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 162px;
  }

  &_content-heading {
    font-weight: bold;
    font-size: 13px;
    color: #2c2c2c;
  }

  &_content-extra {
    font-size: 13px;
    font-weight: normal;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &_content-grid {
    display: flex;
    flex-direction: row;
    margin-left: 144px;
  }

  &_content-grid div {
    width: 319px;
  }


}
</style>
